import { render } from "./DateTypeComponent.vue?vue&type=template&id=2a508297&scoped=true"
import script from "./DateTypeComponent.vue?vue&type=script&lang=js"
export * from "./DateTypeComponent.vue?vue&type=script&lang=js"

import "./DateTypeComponent.vue?vue&type=style&index=0&id=2a508297&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a508297"]])

export default __exports__